import React from "react";
import Notes from "./ui/notes/Notes";
import Layout from "./ui/layout/Layout";


function App() {
    return (
        <Layout/>
    );
}

export default App;
